import React from "react";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import children1 from "../../assets/img/children1.jpg";
import children2 from "../../assets/img/children2.jpg";
import ContactForm from "../../sections/ContactForm";
import Doctor from "../../sections/Doctor";
import OrthodonticPhases from "../../sections/OrthodonticPhases";

export default function Children() {
  return (
    <>
      <div className="bg-children w-full h-[70vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl text-white text-center font-extrabold">
          Детска ортодонтия
        </h1>
      </div>


      <div className="page__width my-20 flex flex-col gap-4 text-center items-center">
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Фази на ортодонтското лечение
        </h2>
        <p className="text-body text-lg w-full lg:w-3/5 text-center">
          Оротдонтското лечение най-често протича в две фази-Фаза 1 ранно орт
          лечение (преди пробива на всички постоянни зъби) и Фаза 2 ( при вече
          пробили всички постоянни зъби).
        </p>
        <OrthodonticPhases />
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={children1} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Предимства на Ранната Намеса
          </h2>
          <p className="text-base text-body font-normal">
            Първият ортодонтски преглед е добре да се случи на около 2-4 г
            възраст, като целта е профилактика на зъбно-челюстните проблеми. По
            време на този преглед ще се прегледа състоянието на зъбите и
            захапката, ще се установи наличието на вредни навици, които биха
            довели до зъбно-челюстни нарушения, проверява се с почистването на
            зъбите на  детето, преглеждат се зъбите за налични кариеси и други
            проблеми.
          </p>
          <p className="text-base text-body font-normal mt-2">
            Отсраняването на вредните навици в тази възраст, подобряването на
            хранителните навици и хигиената на малкото дете, е най-добрата
            профилактика на последващи проблеми със захапката и здравето на
            зъбите.
          </p>

          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={children2} className="w-full" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Корекция на вредните навици
          </h2>
          <p className="text-base text-body font-normal">
            Друг основен проблем, който се лекува във ФАЗА 1 са наличието на
            вредни навици, като неправилна позиция на езика, неправилно дишане
            през устата, хапане на устните, гризане на предмети, смучене на
            палец и др., които могат да са причина за зъбно-чел и лицеви
            деформации.Ранното ортодонтско лечение балансира силите между езика
            и лицевите мускули, което допринася за правилния зъбен, лицев и
            челюстен растеж.
          </p>
          <div className="flex flex-col gap-4 mb-2">
            {/* <div className="flex gap-4 items-center">
                            <div className="p-4 bg-white shadow-icon rounded-md flex items-center justify-center">
                                <Icon
                                    name="pacifier"
                                    className="w-7 h-7 text-brand"
                                />
                            </div>
                            <h3 className="text-2xl font-bold text-heading">
                                Апарат "Биберон"
                            </h3>
                        </div>
                        <div className="flex flex-col mb-2">
                            <p className="text-base text-body font-normal">
                                Специално разработените апаратчета тип “Биберон”
                                могат да помогнат за коригирането на тези
                                навици, осигурявайки правилно развитие на
                                детето.
                            </p>
                        </div> */}
          </div>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <Doctor name="daliya"/>

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic@gmail.com
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
    </>
  );
}
